import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <div className="mx-auto max-w-[1400px] px-5 py-24 md:px-8" data-id="element-1395" data-mp="w3zsnkrmzrwf">
      <p className="font-mono text-sm text-machine" data-id="element-1396" data-mp="w4j9ey5jwa8v">404</p>
      <h1 className="mt-3 font-serif text-4xl text-ink" data-id="element-1397" data-mp="105la7jf48ucy">Nothing counted here.</h1>
      <p className="mt-3 text-muted" data-id="element-1398" data-mp="155h6sxlhhjih">This page isn’t part of the census.</p>
      <Link to="/" className="mt-6 inline-block text-ink underline decoration-machine underline-offset-4" data-id="element-1399" data-mp="152lb7fx3z6x7">
        Back to the census
      </Link>
    </div>;
}